import React from 'react';

import { InfoItem, InfoItemTitle, InfoSection, Paragraph } from './FinancialConsentInfo.styled';

export const FinancialConsentInfo: React.FC = () => {
  return (
    <InfoSection>
      {infoItemTitles.map((title, index) => (
        <InfoItem key={title}>
          <InfoItemTitle>{title}</InfoItemTitle>
          <Paragraph>{paragraphs[index]}</Paragraph>
        </InfoItem>
      ))}
    </InfoSection>
  );
};

const infoItemTitles = [
  'Insurance Presentation',
  'Notification of Insurance Changes',
  'Redetermination of Benefits'
];

const paragraphs = [
  'You must provide your insurance information at the time of service. We cannot accept insurance details after services have been provided due to prior authorization requirements from payors.',
  'If there are any changes to your insurance, you must notify us within 30 days. If you fail to do so, we will not be able to bill your insurance.',
  'In the case of an insurance change, a redetermination of benefits will occur, based on the new coverage. This will override any existing agreements. The coverage will be determined according to the terms set by the payor, and you will be responsible for any non-covered expenses.'
];
